module.exports = __webpack_public_path__ + "media/img/frontend_application/country/ph-bc6ecfb77704012cc04d893e88f5c30b.jpg";